import type { RouteObject } from 'react-router';

import { caseDetailRoute } from './detail/case-detail.route';
import { casesRoute } from './index/cases.route';

/**
 * The case area's two routes, aggregated.
 *
 * The feature backs two routes, so it takes the multi-route shape: one folder
 * per route plus `_shared/` for what both need — the wire types, this surface's
 * wording for the two vocabularies, and the one vocabulary read they share.
 *
 * **One queue, one thread model, one resolution state.** The queue and the
 * detail are two depths of one record rather than two records, which is why the
 * detail reuses the queue's own cache key for the case and why the state control
 * exists on exactly one of them.
 *
 * The pack's `cases/` bucket never reaches a URL: the routes are `/cases` and
 * `/cases/:caseId`.
 */
export const casesRoutes: RouteObject[] = [casesRoute, caseDetailRoute];
